<script type="text/javascript">
    // 定义一些公共的属性和方法
    function isshow() {
			window.screenWidth = document.body.clientWidth;
			let w = window.screenWidth;
			if(w < 1200){
				// console.log('小于1200')
				return false;						
			}else{
				// console.log('大于1200')
				return true;						
			}
        
    }
		
		const imgurl = 'http://www.shuanggou.com/sgadmin'
		const seotit='江苏双沟酒业股份有限公司'
		const seokey='双沟,双沟酒业,江苏双沟酒业股份有限公司'
		const seodec='江苏双沟酒业股份有限公司位于中国白酒之都江苏省宿迁市，座落在淮河与洪泽湖环抱的千年古镇——双沟镇。2021年，双沟酒业以199.64亿元的品牌价值荣登“2021中国品牌价值评价信息榜（轻工业）”第9名。'
		const anionoff=true
    // 暴露出这些属性和方法
    export default {
        isshow,
				imgurl,
				seotit,
				seokey,
				seodec,
				anionoff
    }
</script>
